import { Component } from '@angular/core';
import { ColorVariable, colorVariables, ConfigService, RateNowConfig } from '@nx-ratenow/core/config';
import { ColorSchemeName } from '@nx-ratenow/shared/enums';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'nx-ratenow-config-panel',
  templateUrl: './config-panel.component.html',
  styleUrls: ['./config-panel.component.scss']
})
export class ConfigPanelComponent {
  colorVariables: Record<string, ColorVariable> = colorVariables;

  config$: Observable<RateNowConfig | undefined> = this.configService.config$;

  isRTL$: Observable<boolean> = this.config$.pipe(map((config) => config?.direction === 'rtl'));

  isDark$: Observable<boolean> = this.config$.pipe(map((config) => config?.style.colorScheme === ColorSchemeName.dark));

  ColorSchemeName = ColorSchemeName;
  selectedColor = colorVariables['blue'];

  constructor(private configService: ConfigService) {}

  setConfig(colorScheme: ColorSchemeName): void {
    this.configService.updateConfig({
      style: {
        colorScheme
      }
    });
  }

  selectColor(color: ColorVariable): void {
    this.selectedColor = color;
    this.configService.updateConfig({
      style: {
        colors: {
          primary: {
            default: color.default,
            contrast: color.contrast
          }
        }
      }
    });
  }

  isSelectedColor(color: ColorVariable): boolean {
    return color === this.selectedColor;
  }

  enableDarkMode(): void {
    this.configService.updateConfig({
      style: {
        colorScheme: ColorSchemeName.dark
      }
    });
  }

  disableDarkMode(): void {
    this.configService.updateConfig({
      style: {
        colorScheme: ColorSchemeName.default
      }
    });
  }
}
